import type { CheckboxProps } from '@mui/material'
import { Checkbox } from '@mui/material'

export type CheckboxType = 'circle' | 'square'

interface CustomCheckboxProps extends Omit<CheckboxProps, 'icon' | 'checkedIcon'> {
  checkboxType?: CheckboxType
}

const CustomCheckbox = ({ checkboxType = 'square', ...props }: CustomCheckboxProps) => {
  const isCircle = checkboxType === 'circle'

  return (
    <Checkbox
      {...props}
      sx={{
        '&:hover': {
          backgroundColor: 'transparent',
        },
        ...props.sx,
      }}
      icon={
        isCircle ? (
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
              stroke="#74777F"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg
            width="15"
            height="16"
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.875 5.67578C1.875 4.62568 1.875 4.10063 2.07936 3.69955C2.25913 3.34675 2.54596 3.05991 2.89877 2.88014C3.29985 2.67578 3.8249 2.67578 4.875 2.67578H10.125C11.1751 2.67578 11.7001 2.67578 12.1012 2.88014C12.454 3.05991 12.7409 3.34675 12.9206 3.69955C13.125 4.10063 13.125 4.62568 13.125 5.67578V10.9258C13.125 11.9759 13.125 12.5009 12.9206 12.902C12.7409 13.2548 12.454 13.5417 12.1012 13.7214C11.7001 13.9258 11.1751 13.9258 10.125 13.9258H4.875C3.8249 13.9258 3.29985 13.9258 2.89877 13.7214C2.54596 13.5417 2.25913 13.2548 2.07936 12.902C1.875 12.5009 1.875 11.9759 1.875 10.9258V5.67578Z"
              stroke="#181D29"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )
      }
      checkedIcon={
        isCircle ? (
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
              fill="#5BC06B"
            />
            <path
              d="M5.625 9L7.875 11.25L12.375 6.75M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
              stroke="#E5F5E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.875 4.875C1.875 3.8249 1.875 3.29985 2.07936 2.89877C2.25913 2.54596 2.54596 2.25913 2.89877 2.07936C3.29985 1.875 3.8249 1.875 4.875 1.875H10.125C11.1751 1.875 11.7001 1.875 12.1012 2.07936C12.454 2.25913 12.7409 2.54596 12.9206 2.89877C13.125 3.29985 13.125 3.8249 13.125 4.875V10.125C13.125 11.1751 13.125 11.7001 12.9206 12.1012C12.7409 12.454 12.454 12.7409 12.1012 12.9206C11.7001 13.125 11.1751 13.125 10.125 13.125H4.875C3.8249 13.125 3.29985 13.125 2.89877 12.9206C2.54596 12.7409 2.25913 12.454 2.07936 12.1012C1.875 11.7001 1.875 11.1751 1.875 10.125V4.875Z"
              fill="#5BC06B"
              stroke="#5BC06B"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <g clipPath="url(#clip0_30_23)">
              <path
                d="M10.4444 5.58333L6.625 9.40277L4.88889 7.66666"
                stroke="#FAFAFA"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_30_23">
                <rect
                  width="8.33333"
                  height="8.33333"
                  fill="white"
                  transform="translate(3.5 3.5)"
                />
              </clipPath>
            </defs>
          </svg>
        )
      }
    />
  )
}

export default CustomCheckbox
